<script setup>
import SegmentationTable from '@frontJs/components/tables/projectManagement/sem/SegmentationTable.vue';
import TenantReportSegmentationTable from '@frontJs/components/tables/projectManagement/sem/tenantReports/SegmentationTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Segmentations - SEM - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - Segmentations
    </PageTitle>

    <SegmentationTable v-if="tenant" :tenant="tenant" />
    <TenantReportSegmentationTable v-else />
</template>
